import React from 'react';
import { FadeIn } from '../components/FadeIn';
import { SectionLabel } from '../components/SectionLabel';
import { ArrowRightIcon, ArrowDownIcon } from 'lucide-react';
export function MechanismSection() {
  return <section id="mechanism-section" className="py-14 md:py-20 px-6 bg-midnight scroll-mt-4" data-id="element-248">
      <div className="max-w-4xl mx-auto text-center" data-id="element-249">
        <FadeIn data-id="element-250">
          <SectionLabel text="The Science Behind The Method" data-id="element-251" />
          <h2 className="font-playfair text-3xl md:text-5xl font-bold text-warmwhite mb-10 leading-tight" data-id="element-252">
            Meet The 'Oxygen Pulse' Sequence —<br data-id="element-253" />
            <span className="text-lavender" data-id="element-254">
              The 55-Second Nervous System Reset
            </span>
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-255">
          <div className="font-inter text-lg text-softgray space-y-6 max-w-[680px] mx-auto text-left md:text-center mb-16" data-id="element-256">
            <p data-id="element-257">
              Inside your body right now, anger is a chemical event — not an
              emotional choice.
            </p>
            <p data-id="element-258">
              When you feel rage, your brain floods your bloodstream with
              cortisol and adrenaline. Your heart rate spikes. Your prefrontal
              cortex (the part that makes decisions) goes offline.
            </p>
            <p className="font-medium text-warmwhite" data-id="element-259">
              That's why you can't 'think' your way out of it.
            </p>
            <p data-id="element-260">But here's what they don't teach you:</p>
            <p data-id="element-261">
              Your vagus nerve — the longest nerve in your body — acts as an
              emergency brake for your nervous system. And it has a backdoor.
            </p>
            <p data-id="element-262">
              A specific sequence of oxygen intake and exhale rhythm can
              activate this brake in under 60 seconds — forcing your body out of
              fight-or-flight and back into clarity.
            </p>
            <p className="text-rosegold font-semibold" data-id="element-263">
              We call it The Oxygen Pulse Sequence.
            </p>
            <p data-id="element-264">
              And it works every single time — because it's biology, not
              willpower.
            </p>
          </div>
        </FadeIn>

        {/* Flow Diagram */}
        <FadeIn delay={0.4} data-id="element-265">
          <div className="bg-midnight-light border border-white/10 rounded-2xl p-8 md:p-12" data-id="element-266">
            <div className="flex flex-col md:flex-row items-center justify-between gap-4 md:gap-2" data-id="element-267">
              <div className="flex flex-col items-center text-center w-full md:w-1/4" data-id="element-268">
                <div className="w-16 h-16 rounded-full bg-red-900/20 border border-red-500/30 flex items-center justify-center mb-4" data-id="element-269">
                  <span className="text-2xl" data-id="element-270">🔴</span>
                </div>
                <span className="font-inter font-semibold text-warmwhite text-sm" data-id="element-271">
                  Anger Trigger
                </span>
              </div>

              <ArrowDownIcon className="w-6 h-6 text-softgray md:hidden" data-id="element-272" />
              <ArrowRightIcon className="w-6 h-6 text-softgray hidden md:block" data-id="element-273" />

              <div className="flex flex-col items-center text-center w-full md:w-1/4" data-id="element-274">
                <div className="w-16 h-16 rounded-full bg-orange-900/20 border border-orange-500/30 flex items-center justify-center mb-4" data-id="element-275">
                  <span className="text-2xl" data-id="element-276">⚡</span>
                </div>
                <span className="font-inter font-semibold text-warmwhite text-sm" data-id="element-277">
                  Cortisol Spike
                </span>
              </div>

              <ArrowDownIcon className="w-6 h-6 text-softgray md:hidden" data-id="element-278" />
              <ArrowRightIcon className="w-6 h-6 text-softgray hidden md:block" data-id="element-279" />

              <div className="flex flex-col items-center text-center w-full md:w-1/4" data-id="element-280">
                <div className="w-16 h-16 rounded-full bg-lavender/20 border border-lavender/50 flex items-center justify-center mb-4 shadow-[0_0_15px_rgba(155,142,196,0.3)]" data-id="element-281">
                  <span className="text-2xl" data-id="element-282">🫁</span>
                </div>
                <span className="font-inter font-semibold text-rosegold text-sm" data-id="element-283">
                  Oxygen Pulse Sequence
                </span>
              </div>

              <ArrowDownIcon className="w-6 h-6 text-softgray md:hidden" data-id="element-284" />
              <ArrowRightIcon className="w-6 h-6 text-softgray hidden md:block" data-id="element-285" />

              <div className="flex flex-col items-center text-center w-full md:w-1/4" data-id="element-286">
                <div className="w-16 h-16 rounded-full bg-teal-900/20 border border-teal-500/30 flex items-center justify-center mb-4" data-id="element-287">
                  <span className="text-2xl" data-id="element-288">🟢</span>
                </div>
                <span className="font-inter font-semibold text-warmwhite text-sm" data-id="element-289">
                  Nervous System Reset
                </span>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}